module.exports = __webpack_public_path__ + "static/floor-4-3a4f6e0daf62fdf0582d08635457d4ba.png";